import React, {Component} from 'react'
import './MainNavigationScreen.css'
import CookieBanner from '../components/CookieLawBanner'
import FooterComponent from '../components/FooterComponent'

export default class MainNavigatorScreen extends Component {
  render () {
    return (
      <div>
        <section>
          <div className="main-container container-fluid" style={{padding: 0}}>
            <CookieBanner />
            {this.props.children}
          </div>
        </section>

        <FooterComponent/>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screens/MainNavigatorScreen.js